import React, { useState, useContext } from 'react';
import { MDBInput, MDBBtn } from 'mdbreact';
import { UserContext } from './UserContext';

function AlumniCard(props) {
  const { baseURL } = props;
  const userContext = useContext(UserContext);
  const [rollNumber, setRollNumber] = useState('');
  const isStudentAlum = async (roll) => {
    const res = await fetch(`${baseURL}/api/user/${roll}`);
    if (res.ok) {
      const json = await res.json();
      if (json.info.is_active === false) {
        userContext.login(
          json.info.display_name,
          json.info.email_id,
          'Alumnus',
        );
      }
    } else {
      console.log('Not a student');
    }
  };
  return (
    <div>
      <p>
        Enter your Roll Number to view your NSS Student profile.
      </p>
      <form onSubmit={(e) => {
        e.preventDefault();
        isStudentAlum(rollNumber);
      }}
      >
        <MDBInput
          label="Roll Number"
          onInput={(e) => {
            setRollNumber(e.target.value);
          }}
          value={rollNumber}
          id="rollNum"
          required
        />
        {/* <MDBBtn
          color="blue"
          type="button"
          onClick={() => isStudentAlum(rollNumber)}
        >
          Generate
        </MDBBtn> */}
        <MDBBtn color="red" type="submit">
          Login
        </MDBBtn>
      </form>
    </div>
  );
}

export default AlumniCard;
